<template>
  <div>
    <!-- Reset Password Dialog -->
    <v-layout justify-center>
      <v-dialog
        v-model="pwResetDialog"
        persistent
        max-width="600px">
        <v-card>
          <v-form
            v-model='validForm'
            ref="pwResetForm">
            <v-card-title>
              <span class="headline">Reset Password</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field
                      type='password'
                      v-model='oldPW'
                      label="Old Password"
                      required></v-text-field>
                  </v-flex>

                  <v-flex xs12>
                    <v-text-field
                      :append-icon="show ? 'visibility' : 'visibility_off'"
                      @click:append="show = !show"
                      :type="show ? 'text' : 'password'"
                      :rules='passwordRules'
                      v-model='newPW'
                      label="Please enter a new password."
                      required
                      outline></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      :type="show ? 'text' : 'password'"
                      :rules='verifyRules'
                      label="Please verify your new password."
                      required
                      outline></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                text
                @click="pwResetDialog=false">Close</v-btn>
              <v-btn
                :disabled="!validForm"
                color="primary"
                text
                @click="resetPW">Save</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout justify-center>
      <v-dialog
        v-model="deleteDialog"
        persistent
        max-width="600px">
        <v-card>
          <v-form
            v-model='validForm'
            ref="deleteForm">
            <v-card-title>
              <span class="headline">DELETE ACCOUNT</span>
            </v-card-title>

            <v-card-text>
              Once you hit send your account will be deleted. All data stored under your account will no longer be accessible. There is no turning back once the account has been deleted.
              </br></br>
              Please enter your password if you are sure you want to delete your account.

              <v-text-field
                type='password'
                v-model='deletePW'
                label="Enter you password here."
                required
                outline></v-text-field>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                text
                @click="deleteDialog=false">Cancel</v-btn>
              <v-btn
                :disabled="!validForm"
                color="primary"
                text
                @click="accountDelete">Send</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout justify-center>
      <v-dialog
        v-model="reviewDialog"
        persistent
        max-width="600px">
        <v-card>
          <v-form
            v-model='validForm'
            ref="reviewForm">
            <v-card-title>
              <span class="headline">Review Status</span>
            </v-card-title>

            <v-card-text>
              Click submit to let our genetic counselors know you are ready for them to view your information.
              <center>
                <ReviewFlag/>
              </center>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="reviewDialog=false">Done</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-layout>

    <!-- Account management form -->
    <v-card color='primary'>
      <v-layout
        column
        fill-height>
        <v-card-title class="white--text pl-5 pt-5">
          <v-spacer>Account Management</v-spacer>
        </v-card-title>
      </v-layout>

      <v-list
        two-line>
        <v-list-item
          @click='pwResetDialog=true'>
          <v-list-item-action>
            <v-icon color="primary">mdi-lock-reset</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>Reset Password</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider inset></v-divider>

        <v-list-item
          v-if="this.user.complete"
          @click='reviewDialog=true'>
          <v-list-item-action>
            <v-icon color="primary">mdi-file-find</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>Review Status</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider inset></v-divider>

        <v-list-item
          @click='deleteDialog=true'>
          <v-list-item-action>
            <v-icon color="primary">mdi-delete</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>Delete Account</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </div>
</template>


<script>
  import { mapFields } from 'vuex-map-fields';
  import router from '@/router';
  import { editUserData, resetPassword, deleteAccount } from '../../helper/firestore';
  import ReviewFlag from '../ReviewFlag';

  export default {
    data () {
      return {
        validForm: false,
        deleteDialog: false,
        reviewDialog: false,
        pwResetDialog: false,
        oldPW: '',
        newPW: '',
        show: false,
        deletePW: '',
        passwordRules: [
          v => /[a-z]+/.test(v) || 'One lowercase letter required.',
          v => /[A-Z]+/.test(v) || 'One uppercase letter required.',
          v => /.{8,}/.test(v) || '8 characters minimum.',
          v => /[0-9]+/.test(v) || 'One number required.'
        ],
        verifyRules: [
          v => v === this.newPW || 'Passwords must match'
        ],
      }
    },
    mounted() {

    },
    methods: {
      resetPW() {
        const options = {
          "email": this.user.info.email,
          "oldPassword": this.oldPW,
          "newPassword": this.newPW
        }
        resetPassword(options, (res) => {
          if (res.status === 200) {
            this.pwResetDialog = false;
          } else {
            switch (res.response.data) {
              case 'INCORRECT_PASSWORD':
                this.snackBarmessage = "The old password was incorrect.";
                break;
              default:
                this.snackBarmessage = "There was a problem changing your password.";
                break;
            }
            this.snackBarType = "warning";
            this.snackBarshow = true;
          }
        });
      },
      accountDelete() {
        const options = {
          "email": this.user.info.email,
          "password": this.deletePW
        }
        deleteAccount(options, (res) => {
          if (res.status === 200) {
              window.location.reload();
          } else {
            switch (res.response.data) {
              case 'INCORRECT_PASSWORD':
                this.snackBarmessage = "The old password was incorrect.";
                break;
              default:
                this.snackBarmessage = "There was a problem deleting your account.";
                break;
            }
            this.snackBarType = "warning";
            this.snackBarshow = true;
          }
        });
      },
    },
    computed: {
      ...mapFields([
        'user',
        'isAuthorized',
        'snackBarshow',
        'snackBarType',
        'snackBarmessage',
      ]),
      ...mapFields("patientQuestion", [
        "relations"
      ]),
    },
    components: {
      ReviewFlag
    }
  }
</script>
